export enum PerformanceObserverEntryTypes {
    LayoutShift = "layout-shift",
    LongTask = "longtask"
}
